export default __webpack_public_path__ + "static/media/atm.56bd6f54.svg";